<template>
  <circle
    class="Dot"
    :cx="x"
    :cy="y"
    :r="strokeWidth"
    @click="onClick"
    @mouseover="handleMouseover(onMouseover)"
    @mouseout="handleMouseout(onMouseout)"
    v-bind="styleForDot"
  />
</template>

<script>
import { defineComponent, ref, computed } from 'vue';

import Datum from './datum.vue';

export default defineComponent({
  name: 'DatalasDot',

  extends: Datum,
  props: {
    heading: {
      type: String,
      default: '',
    },
    message: {
      type: String,
      default: '',
    },
    strokeWidth: {
      type: Number,
      default: 0,
    },
    showOnHover: Boolean,
  },
  setup(props) {
    const hovered = ref(false);

    const handleMouseover = (method) => {
      hovered.value = true;
      method();
    };
    const handleMouseout = (method) => {
      hovered.value = false;
      method();
    };
    const styleForDot = computed(() => {
      if (props.showOnHover) {
        return {
          'fill-opacity': hovered.value ? 1 : 0,
          style: `cursor: pointer; transition: 0.3s; fill: ${props.datum.fill}`,
        };
      }
      return { fill: props.fill };
    });

    return {
      handleMouseover,
      handleMouseout,
      styleForDot,
    };
  },
});
</script>
